export default __webpack_public_path__ + "static/media/ads_bg.a6c05716.svg";